import {ContainerCluster, ContainerClusterEntity} from "../../../model/container-cluster";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ContainerClusterSelectorProps = {
  regionId?: string
  siteId?: string
};

const getRegionIdParam = createParamSelector<ContainerClusterSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getSiteIdParam = createParamSelector<ContainerClusterSelectorProps | undefined, string | undefined>(params => params?.siteId);

export const containerClustersSelector = () => createSelector(
  [
    getUseQueryResultData<ContainerCluster[]>,
    getRegionIdParam,
    getSiteIdParam,
  ],
  (data, regionId, siteId) => {
    return selectContainerClustersAndTransform(data ?? [], {
      regionId: regionId,
      siteId: siteId,
    });
  }
);

export const containerClusterSelector = () => createSelector(
  [getUseQueryResultData<ContainerCluster>],
  (data) => {
    return data ? transformContainerCluster(data) : undefined;
  }
);

export const selectContainerClusters = (values?: ContainerCluster[], selector?: ContainerClusterSelectorProps): ContainerCluster[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (selector.regionId !== v.regionId) {
        filterIn = false
      }
    }

    if (selector?.siteId) {
      if (selector.siteId !== v.siteId) {
        filterIn = false
      }
    }

    return filterIn;
  });
};

export const transformContainerCluster = (value: ContainerCluster): ContainerClusterEntity => {
  return ContainerClusterEntity.from(value)
}

export const selectContainerClustersAndTransform = (values?: ContainerCluster[], selector?: ContainerClusterSelectorProps): ContainerClusterEntity[] => {
  const selected = selectContainerClusters(values, selector);
  return selected.map(transformContainerCluster);
};
